// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var FormV5 = require("../../uikit/reason/atoms/Form/FormV5.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Formality = require("../../vendor/re-formality/Formality.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
var Form__Components = require("../../reason/common/Form/Form__Components.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var ProfilePageSocialMediaForm_agent_graphql = require("../../__generated__/ProfilePageSocialMediaForm_agent_graphql.bs.js");
var ProfilePageSocialMediaForm_UpdateAgentSocialMediaHandlesMutation_graphql = require("../../__generated__/ProfilePageSocialMediaForm_UpdateAgentSocialMediaHandlesMutation_graphql.bs.js");

var validators_facebookHandle = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param) {
      return {
              TAG: "Ok",
              _0: param.facebookHandle
            };
    })
};

var validators_instagramHandle = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param) {
      return {
              TAG: "Ok",
              _0: param.instagramHandle
            };
    })
};

var validators_linkedInHandle = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param) {
      return {
              TAG: "Ok",
              _0: param.linkedInHandle
            };
    })
};

var validators_twitterHandle = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param) {
      return {
              TAG: "Ok",
              _0: param.twitterHandle
            };
    })
};

var validators_yelpHandle = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param) {
      return {
              TAG: "Ok",
              _0: param.yelpHandle
            };
    })
};

var validators_youTubeHandle = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param) {
      return {
              TAG: "Ok",
              _0: param.youTubeHandle
            };
    })
};

var validators = {
  facebookHandle: validators_facebookHandle,
  instagramHandle: validators_instagramHandle,
  linkedInHandle: validators_linkedInHandle,
  twitterHandle: validators_twitterHandle,
  yelpHandle: validators_yelpHandle,
  youTubeHandle: validators_youTubeHandle
};

function initialFieldsStatuses(_input) {
  return {
          facebookHandle: "Pristine",
          instagramHandle: "Pristine",
          linkedInHandle: "Pristine",
          twitterHandle: "Pristine",
          yelpHandle: "Pristine",
          youTubeHandle: "Pristine"
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: "Editing",
          submissionStatus: "NeverSubmitted"
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.facebookHandle;
  var tmp;
  tmp = typeof match !== "object" ? validators.facebookHandle.validate(input) : match._0;
  var match$1 = fieldsStatuses.instagramHandle;
  var tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.instagramHandle.validate(input) : match$1._0;
  var match$2 = fieldsStatuses.linkedInHandle;
  var tmp$2;
  tmp$2 = typeof match$2 !== "object" ? validators.linkedInHandle.validate(input) : match$2._0;
  var match$3 = fieldsStatuses.twitterHandle;
  var tmp$3;
  tmp$3 = typeof match$3 !== "object" ? validators.twitterHandle.validate(input) : match$3._0;
  var match$4 = fieldsStatuses.yelpHandle;
  var tmp$4;
  tmp$4 = typeof match$4 !== "object" ? validators.yelpHandle.validate(input) : match$4._0;
  var match$5 = fieldsStatuses.youTubeHandle;
  var tmp$5;
  tmp$5 = typeof match$5 !== "object" ? validators.youTubeHandle.validate(input) : match$5._0;
  var facebookHandleResult = tmp;
  var facebookHandleResult$1;
  if (facebookHandleResult.TAG === "Ok") {
    var instagramHandleResult = tmp$1;
    if (instagramHandleResult.TAG === "Ok") {
      var linkedInHandleResult = tmp$2;
      if (linkedInHandleResult.TAG === "Ok") {
        var twitterHandleResult = tmp$3;
        if (twitterHandleResult.TAG === "Ok") {
          var yelpHandleResult = tmp$4;
          if (yelpHandleResult.TAG === "Ok") {
            var youTubeHandleResult = tmp$5;
            if (youTubeHandleResult.TAG === "Ok") {
              return {
                      TAG: "Valid",
                      output: {
                        facebookHandle: facebookHandleResult._0,
                        instagramHandle: instagramHandleResult._0,
                        linkedInHandle: linkedInHandleResult._0,
                        twitterHandle: twitterHandleResult._0,
                        yelpHandle: yelpHandleResult._0,
                        youTubeHandle: youTubeHandleResult._0
                      },
                      fieldsStatuses: {
                        facebookHandle: {
                          TAG: "Dirty",
                          _0: facebookHandleResult,
                          _1: "Shown"
                        },
                        instagramHandle: {
                          TAG: "Dirty",
                          _0: instagramHandleResult,
                          _1: "Shown"
                        },
                        linkedInHandle: {
                          TAG: "Dirty",
                          _0: linkedInHandleResult,
                          _1: "Shown"
                        },
                        twitterHandle: {
                          TAG: "Dirty",
                          _0: twitterHandleResult,
                          _1: "Shown"
                        },
                        yelpHandle: {
                          TAG: "Dirty",
                          _0: yelpHandleResult,
                          _1: "Shown"
                        },
                        youTubeHandle: {
                          TAG: "Dirty",
                          _0: youTubeHandleResult,
                          _1: "Shown"
                        }
                      },
                      collectionsStatuses: undefined
                    };
            }
            facebookHandleResult$1 = facebookHandleResult;
          } else {
            facebookHandleResult$1 = facebookHandleResult;
          }
        } else {
          facebookHandleResult$1 = facebookHandleResult;
        }
      } else {
        facebookHandleResult$1 = facebookHandleResult;
      }
    } else {
      facebookHandleResult$1 = facebookHandleResult;
    }
  } else {
    facebookHandleResult$1 = facebookHandleResult;
  }
  return {
          TAG: "Invalid",
          fieldsStatuses: {
            facebookHandle: {
              TAG: "Dirty",
              _0: facebookHandleResult$1,
              _1: "Shown"
            },
            instagramHandle: {
              TAG: "Dirty",
              _0: tmp$1,
              _1: "Shown"
            },
            linkedInHandle: {
              TAG: "Dirty",
              _0: tmp$2,
              _1: "Shown"
            },
            twitterHandle: {
              TAG: "Dirty",
              _0: tmp$3,
              _1: "Shown"
            },
            yelpHandle: {
              TAG: "Dirty",
              _0: tmp$4,
              _1: "Shown"
            },
            youTubeHandle: {
              TAG: "Dirty",
              _0: tmp$5,
              _1: "Shown"
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action !== "object") {
            switch (action) {
              case "BlurFacebookHandleField" :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.facebookHandle, validators_facebookHandle, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  facebookHandle: status,
                                  instagramHandle: init.instagramHandle,
                                  linkedInHandle: init.linkedInHandle,
                                  twitterHandle: init.twitterHandle,
                                  yelpHandle: init.yelpHandle,
                                  youTubeHandle: init.youTubeHandle
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurInstagramHandleField" :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.instagramHandle, validators_instagramHandle, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  facebookHandle: init.facebookHandle,
                                  instagramHandle: status,
                                  linkedInHandle: init.linkedInHandle,
                                  twitterHandle: init.twitterHandle,
                                  yelpHandle: init.yelpHandle,
                                  youTubeHandle: init.youTubeHandle
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurLinkedInHandleField" :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.linkedInHandle, validators_linkedInHandle, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  facebookHandle: init.facebookHandle,
                                  instagramHandle: init.instagramHandle,
                                  linkedInHandle: status,
                                  twitterHandle: init.twitterHandle,
                                  yelpHandle: init.yelpHandle,
                                  youTubeHandle: init.youTubeHandle
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurTwitterHandleField" :
                  var result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.twitterHandle, validators_twitterHandle, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  facebookHandle: init.facebookHandle,
                                  instagramHandle: init.instagramHandle,
                                  linkedInHandle: init.linkedInHandle,
                                  twitterHandle: status,
                                  yelpHandle: init.yelpHandle,
                                  youTubeHandle: init.youTubeHandle
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurYelpHandleField" :
                  var result$4 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.yelpHandle, validators_yelpHandle, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  facebookHandle: init.facebookHandle,
                                  instagramHandle: init.instagramHandle,
                                  linkedInHandle: init.linkedInHandle,
                                  twitterHandle: init.twitterHandle,
                                  yelpHandle: status,
                                  youTubeHandle: init.youTubeHandle
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurYouTubeHandleField" :
                  var result$5 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.youTubeHandle, validators_youTubeHandle, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  facebookHandle: init.facebookHandle,
                                  instagramHandle: init.instagramHandle,
                                  linkedInHandle: init.linkedInHandle,
                                  twitterHandle: init.twitterHandle,
                                  yelpHandle: init.yelpHandle,
                                  youTubeHandle: status
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "Submit" :
                  var match = state.formStatus;
                  if (typeof match === "object" && match.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== "Valid") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: "AttemptedToSubmit"
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
                  return {
                          TAG: "UpdateWithSideEffects",
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: "Submitting",
                              _0: tmp
                            },
                            submissionStatus: "AttemptedToSubmit"
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              onSubmit(output, {
                                    notifyOnSuccess: (function (input) {
                                        dispatch({
                                              TAG: "SetSubmittedStatus",
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        dispatch({
                                              TAG: "SetSubmissionFailedStatus",
                                              _0: error
                                            });
                                      }),
                                    reset: (function () {
                                        dispatch("Reset");
                                      }),
                                    dismissSubmissionResult: (function () {
                                        dispatch("DismissSubmissionResult");
                                      })
                                  });
                            })
                        };
                  break;
              case "DismissSubmissionError" :
                  var match$2 = state.formStatus;
                  if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
                    return "NoUpdate";
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "DismissSubmissionResult" :
                  var match$3 = state.formStatus;
                  if (typeof match$3 !== "object") {
                    if (match$3 === "Editing") {
                      return "NoUpdate";
                    }
                    
                  } else if (match$3.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: "Editing",
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "Reset" :
                  return {
                          TAG: "Update",
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG) {
              case "UpdateFacebookHandleField" :
                  var nextInput = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.facebookHandle, state.submissionStatus, validators_facebookHandle, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            facebookHandle: status,
                                            instagramHandle: init.instagramHandle,
                                            linkedInHandle: init.linkedInHandle,
                                            twitterHandle: init.twitterHandle,
                                            yelpHandle: init.yelpHandle,
                                            youTubeHandle: init.youTubeHandle
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateInstagramHandleField" :
                  var nextInput$1 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.instagramHandle, state.submissionStatus, validators_instagramHandle, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            facebookHandle: init.facebookHandle,
                                            instagramHandle: status,
                                            linkedInHandle: init.linkedInHandle,
                                            twitterHandle: init.twitterHandle,
                                            yelpHandle: init.yelpHandle,
                                            youTubeHandle: init.youTubeHandle
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateLinkedInHandleField" :
                  var nextInput$2 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.linkedInHandle, state.submissionStatus, validators_linkedInHandle, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            facebookHandle: init.facebookHandle,
                                            instagramHandle: init.instagramHandle,
                                            linkedInHandle: status,
                                            twitterHandle: init.twitterHandle,
                                            yelpHandle: init.yelpHandle,
                                            youTubeHandle: init.youTubeHandle
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateTwitterHandleField" :
                  var nextInput$3 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, state.fieldsStatuses.twitterHandle, state.submissionStatus, validators_twitterHandle, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            facebookHandle: init.facebookHandle,
                                            instagramHandle: init.instagramHandle,
                                            linkedInHandle: init.linkedInHandle,
                                            twitterHandle: status,
                                            yelpHandle: init.yelpHandle,
                                            youTubeHandle: init.youTubeHandle
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateYelpHandleField" :
                  var nextInput$4 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$4, state.fieldsStatuses.yelpHandle, state.submissionStatus, validators_yelpHandle, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            facebookHandle: init.facebookHandle,
                                            instagramHandle: init.instagramHandle,
                                            linkedInHandle: init.linkedInHandle,
                                            twitterHandle: init.twitterHandle,
                                            yelpHandle: status,
                                            youTubeHandle: init.youTubeHandle
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateYouTubeHandleField" :
                  var nextInput$5 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$5, state.fieldsStatuses.youTubeHandle, state.submissionStatus, validators_youTubeHandle, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            facebookHandle: init.facebookHandle,
                                            instagramHandle: init.instagramHandle,
                                            linkedInHandle: init.linkedInHandle,
                                            twitterHandle: init.twitterHandle,
                                            yelpHandle: init.yelpHandle,
                                            youTubeHandle: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "SetSubmittedStatus" :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "SetSubmissionFailedStatus" :
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: "SubmissionFailed",
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "MapSubmissionError" :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 !== "object") {
                    return "NoUpdate";
                  }
                  if (error$1.TAG !== "Submitting") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "SubmissionFailed",
                                _0: map(error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "Submitting",
                                _0: map(error$2)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 !== "object" || match$1.TAG !== "Submitting" ? false : true;
  return {
          updateFacebookHandle: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateFacebookHandleField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateInstagramHandle: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateInstagramHandleField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateLinkedInHandle: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateLinkedInHandleField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateTwitterHandle: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateTwitterHandleField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateYelpHandle: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateYelpHandleField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateYouTubeHandle: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateYouTubeHandleField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          blurFacebookHandle: (function () {
              dispatch("BlurFacebookHandleField");
            }),
          blurInstagramHandle: (function () {
              dispatch("BlurInstagramHandleField");
            }),
          blurLinkedInHandle: (function () {
              dispatch("BlurLinkedInHandleField");
            }),
          blurTwitterHandle: (function () {
              dispatch("BlurTwitterHandleField");
            }),
          blurYelpHandle: (function () {
              dispatch("BlurYelpHandleField");
            }),
          blurYouTubeHandle: (function () {
              dispatch("BlurYouTubeHandleField");
            }),
          facebookHandleResult: Formality.exposeFieldResult(state.fieldsStatuses.facebookHandle),
          instagramHandleResult: Formality.exposeFieldResult(state.fieldsStatuses.instagramHandle),
          linkedInHandleResult: Formality.exposeFieldResult(state.fieldsStatuses.linkedInHandle),
          twitterHandleResult: Formality.exposeFieldResult(state.fieldsStatuses.twitterHandle),
          yelpHandleResult: Formality.exposeFieldResult(state.fieldsStatuses.yelpHandle),
          youTubeHandleResult: Formality.exposeFieldResult(state.fieldsStatuses.youTubeHandle),
          input: state.input,
          status: state.formStatus,
          dirty: (function () {
              var match = state.fieldsStatuses;
              var tmp = match.facebookHandle;
              if (typeof tmp === "object") {
                return true;
              }
              var tmp$1 = match.instagramHandle;
              if (typeof tmp$1 === "object") {
                return true;
              }
              var tmp$2 = match.linkedInHandle;
              if (typeof tmp$2 === "object") {
                return true;
              }
              var tmp$3 = match.twitterHandle;
              if (typeof tmp$3 === "object") {
                return true;
              }
              var tmp$4 = match.yelpHandle;
              if (typeof tmp$4 === "object") {
                return true;
              }
              var tmp$5 = match.youTubeHandle;
              if (typeof tmp$5 !== "object") {
                return false;
              } else {
                return true;
              }
            }),
          valid: (function () {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === "Valid") {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function () {
              dispatch("Submit");
            }),
          dismissSubmissionError: (function () {
              dispatch("DismissSubmissionError");
            }),
          dismissSubmissionResult: (function () {
              dispatch("DismissSubmissionResult");
            }),
          mapSubmissionError: (function (map) {
              dispatch({
                    TAG: "MapSubmissionError",
                    _0: map
                  });
            }),
          reset: (function () {
              dispatch("Reset");
            })
        };
}

var FormConfig = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

var convertVariables = ProfilePageSocialMediaForm_UpdateAgentSocialMediaHandlesMutation_graphql.Internal.convertVariables;

var convertResponse = ProfilePageSocialMediaForm_UpdateAgentSocialMediaHandlesMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = ProfilePageSocialMediaForm_UpdateAgentSocialMediaHandlesMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, ProfilePageSocialMediaForm_UpdateAgentSocialMediaHandlesMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use = RescriptRelay_Mutation.useMutation(convertVariables, ProfilePageSocialMediaForm_UpdateAgentSocialMediaHandlesMutation_graphql.node, convertResponse, convertWrapRawResponse);

var UpdateAgentSocialMediaHandlesMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

var convertFragment = ProfilePageSocialMediaForm_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ProfilePageSocialMediaForm_agent_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ProfilePageSocialMediaForm_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ProfilePageSocialMediaForm_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ProfilePageSocialMediaForm_agent_graphql.node, convertFragment, fRef);
}

var AgentFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ProfilePageSocialMediaForm(props) {
  var agent = use$1(props.agent);
  var match = use();
  var updateSocialMedia = match[0];
  var form = useForm({
        facebookHandle: agent.socialMedia.facebookHandle,
        instagramHandle: agent.socialMedia.instagramHandle,
        linkedInHandle: agent.socialMedia.linkedInHandle,
        twitterHandle: agent.socialMedia.twitterHandle,
        yelpHandle: agent.socialMedia.yelpHandle,
        youTubeHandle: agent.socialMedia.youTubeHandle
      }, (function (param, param$1) {
          var notifyOnFailure = param$1.notifyOnFailure;
          var notifyOnSuccess = param$1.notifyOnSuccess;
          updateSocialMedia({
                input: {
                  facebookHandle: param.facebookHandle,
                  instagramHandle: param.instagramHandle,
                  linkedInHandle: param.linkedInHandle,
                  twitterHandle: param.twitterHandle,
                  yelpHandle: param.yelpHandle,
                  youTubeHandle: param.youTubeHandle
                }
              }, undefined, undefined, undefined, (function (param, param$1) {
                  var updateAgentSocialMediaHandles = param.updateAgentSocialMediaHandles;
                  if (updateAgentSocialMediaHandles !== undefined && updateAgentSocialMediaHandles.__typename === "Agent") {
                    return notifyOnSuccess(undefined);
                  } else {
                    return notifyOnFailure("Error updating data. Please refresh and try again...");
                  }
                }), undefined, undefined);
        }));
  var match$1 = form.facebookHandleResult;
  var tmp;
  tmp = match$1 !== undefined && match$1.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$1._0
      }) : undefined;
  var match$2 = form.twitterHandleResult;
  var tmp$1;
  tmp$1 = match$2 !== undefined && match$2.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$2._0
      }) : undefined;
  var match$3 = form.instagramHandleResult;
  var tmp$2;
  tmp$2 = match$3 !== undefined && match$3.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$3._0
      }) : undefined;
  var match$4 = form.yelpHandleResult;
  var tmp$3;
  tmp$3 = match$4 !== undefined && match$4.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$4._0
      }) : undefined;
  var match$5 = form.linkedInHandleResult;
  var tmp$4;
  tmp$4 = match$5 !== undefined && match$5.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$5._0
      }) : undefined;
  var match$6 = form.youTubeHandleResult;
  var tmp$5;
  tmp$5 = match$6 !== undefined && match$6.TAG !== "Ok" ? ({
        NAME: "Error",
        VAL: match$6._0
      }) : undefined;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        "Social accounts",
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Form__Components.FormStatusMessageV2.make, {
                                    status: form.status,
                                    submissionErrorToString: (function (v) {
                                        return v;
                                      }),
                                    onSuccessMessage: "Account updated",
                                    resetForm: form.reset,
                                    dismissSubmissionResult: form.dismissSubmissionResult
                                  }),
                              className: "my-4"
                            })
                      ],
                      className: "text-2xl border-b pb-4 font-semibold mb-8"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("p", {
                            children: "Add links to your social media accounts. They'll appear on your TAN member profile."
                          }),
                      className: "mb-8"
                    }),
                JsxRuntime.jsxs(FormV5.FormGroup.make, {
                      label: "Facebook:",
                      children: [
                        JsxRuntime.jsx(Form__Input.make, {
                              type: "text",
                              onChange: (function ($$event) {
                                  form.updateFacebookHandle((function (v, value) {
                                          return {
                                                  facebookHandle: Form__Helpers.noneIfEmpty(value),
                                                  instagramHandle: v.instagramHandle,
                                                  linkedInHandle: v.linkedInHandle,
                                                  twitterHandle: v.twitterHandle,
                                                  yelpHandle: v.yelpHandle,
                                                  youTubeHandle: v.youTubeHandle
                                                };
                                        }), $$event.target.value);
                                }),
                              onBlur: (function (param) {
                                  form.blurFacebookHandle();
                                }),
                              disabled: form.submitting,
                              status: Core__Option.map(form.facebookHandleResult, (function (x) {
                                      if (x.TAG === "Ok") {
                                        return "ok";
                                      } else {
                                        return "error";
                                      }
                                    })),
                              value: Core__Option.getOr(form.input.facebookHandle, "")
                            }),
                        JsxRuntime.jsx(Form__Components.FieldError.make, {
                              valid: tmp
                            })
                      ]
                    }),
                JsxRuntime.jsxs(FormV5.FormGroup.make, {
                      label: "Twitter:",
                      children: [
                        JsxRuntime.jsx(Form__Input.make, {
                              type: "text",
                              onChange: (function ($$event) {
                                  form.updateTwitterHandle((function (v, value) {
                                          return {
                                                  facebookHandle: v.facebookHandle,
                                                  instagramHandle: v.instagramHandle,
                                                  linkedInHandle: v.linkedInHandle,
                                                  twitterHandle: Form__Helpers.noneIfEmpty(value),
                                                  yelpHandle: v.yelpHandle,
                                                  youTubeHandle: v.youTubeHandle
                                                };
                                        }), $$event.target.value);
                                }),
                              onBlur: (function (param) {
                                  form.blurTwitterHandle();
                                }),
                              disabled: form.submitting,
                              status: Core__Option.map(form.twitterHandleResult, (function (x) {
                                      if (x.TAG === "Ok") {
                                        return "ok";
                                      } else {
                                        return "error";
                                      }
                                    })),
                              value: Core__Option.getOr(form.input.twitterHandle, "")
                            }),
                        JsxRuntime.jsx(Form__Components.FieldError.make, {
                              valid: tmp$1
                            })
                      ]
                    }),
                JsxRuntime.jsxs(FormV5.FormGroup.make, {
                      label: "Instagram:",
                      children: [
                        JsxRuntime.jsx(Form__Input.make, {
                              type: "text",
                              onChange: (function ($$event) {
                                  form.updateInstagramHandle((function (v, value) {
                                          return {
                                                  facebookHandle: v.facebookHandle,
                                                  instagramHandle: Form__Helpers.noneIfEmpty(value),
                                                  linkedInHandle: v.linkedInHandle,
                                                  twitterHandle: v.twitterHandle,
                                                  yelpHandle: v.yelpHandle,
                                                  youTubeHandle: v.youTubeHandle
                                                };
                                        }), $$event.target.value);
                                }),
                              onBlur: (function (param) {
                                  form.blurInstagramHandle();
                                }),
                              disabled: form.submitting,
                              status: Core__Option.map(form.instagramHandleResult, (function (x) {
                                      if (x.TAG === "Ok") {
                                        return "ok";
                                      } else {
                                        return "error";
                                      }
                                    })),
                              value: Core__Option.getOr(form.input.instagramHandle, "")
                            }),
                        JsxRuntime.jsx(Form__Components.FieldError.make, {
                              valid: tmp$2
                            })
                      ]
                    }),
                JsxRuntime.jsxs(FormV5.FormGroup.make, {
                      label: "Yelp:",
                      children: [
                        JsxRuntime.jsx(Form__Input.make, {
                              type: "text",
                              onChange: (function ($$event) {
                                  form.updateYelpHandle((function (v, value) {
                                          return {
                                                  facebookHandle: v.facebookHandle,
                                                  instagramHandle: v.instagramHandle,
                                                  linkedInHandle: v.linkedInHandle,
                                                  twitterHandle: v.twitterHandle,
                                                  yelpHandle: Form__Helpers.noneIfEmpty(value),
                                                  youTubeHandle: v.youTubeHandle
                                                };
                                        }), $$event.target.value);
                                }),
                              onBlur: (function (param) {
                                  form.blurYelpHandle();
                                }),
                              disabled: form.submitting,
                              status: Core__Option.map(form.yelpHandleResult, (function (x) {
                                      if (x.TAG === "Ok") {
                                        return "ok";
                                      } else {
                                        return "error";
                                      }
                                    })),
                              value: Core__Option.getOr(form.input.yelpHandle, "")
                            }),
                        JsxRuntime.jsx(Form__Components.FieldError.make, {
                              valid: tmp$3
                            })
                      ]
                    }),
                JsxRuntime.jsxs(FormV5.FormGroup.make, {
                      label: "LinkedIn:",
                      children: [
                        JsxRuntime.jsx(Form__Input.make, {
                              type: "text",
                              onChange: (function ($$event) {
                                  form.updateLinkedInHandle((function (v, value) {
                                          return {
                                                  facebookHandle: v.facebookHandle,
                                                  instagramHandle: v.instagramHandle,
                                                  linkedInHandle: Form__Helpers.noneIfEmpty(value),
                                                  twitterHandle: v.twitterHandle,
                                                  yelpHandle: v.yelpHandle,
                                                  youTubeHandle: v.youTubeHandle
                                                };
                                        }), $$event.target.value);
                                }),
                              onBlur: (function (param) {
                                  form.blurLinkedInHandle();
                                }),
                              disabled: form.submitting,
                              status: Core__Option.map(form.linkedInHandleResult, (function (x) {
                                      if (x.TAG === "Ok") {
                                        return "ok";
                                      } else {
                                        return "error";
                                      }
                                    })),
                              value: Core__Option.getOr(form.input.linkedInHandle, "")
                            }),
                        JsxRuntime.jsx(Form__Components.FieldError.make, {
                              valid: tmp$4
                            })
                      ]
                    }),
                JsxRuntime.jsxs(FormV5.FormGroup.make, {
                      label: "Youtube:",
                      children: [
                        JsxRuntime.jsx(Form__Input.make, {
                              type: "text",
                              onChange: (function ($$event) {
                                  form.updateYouTubeHandle((function (v, value) {
                                          return {
                                                  facebookHandle: v.facebookHandle,
                                                  instagramHandle: v.instagramHandle,
                                                  linkedInHandle: v.linkedInHandle,
                                                  twitterHandle: v.twitterHandle,
                                                  yelpHandle: v.yelpHandle,
                                                  youTubeHandle: Form__Helpers.noneIfEmpty(value)
                                                };
                                        }), $$event.target.value);
                                }),
                              onBlur: (function (param) {
                                  form.blurYouTubeHandle();
                                }),
                              disabled: form.submitting,
                              status: Core__Option.map(form.youTubeHandleResult, (function (x) {
                                      if (x.TAG === "Ok") {
                                        return "ok";
                                      } else {
                                        return "error";
                                      }
                                    })),
                              value: Core__Option.getOr(form.input.youTubeHandle, "")
                            }),
                        JsxRuntime.jsx(Form__Components.FieldError.make, {
                              valid: tmp$5
                            })
                      ]
                    }),
                JsxRuntime.jsx(FormV5.FormGroup.make, {
                      children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                            onClick: (function (extra) {
                                return Form__Helpers.preventDefault(form.submit, extra);
                              }),
                            disabled: !form.valid() || form.submitting,
                            children: "Save"
                          })
                    })
              ],
              className: "flex flex-col my-8"
            });
}

var PrimaryButton;

var make = ProfilePageSocialMediaForm;

exports.FormConfig = FormConfig;
exports.UpdateAgentSocialMediaHandlesMutation = UpdateAgentSocialMediaHandlesMutation;
exports.AgentFragment = AgentFragment;
exports.PrimaryButton = PrimaryButton;
exports.make = make;
/* commitMutation Not a pure module */
